<template>
  <div class="sort-arrow">
    <svg v-if="!ascending" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill-opacity="0.54" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z"/>
      <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/>
    </svg>

    <svg v-if="ascending" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill-opacity="0.54" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z"/>
      <path fill="#010101" d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SortArrow',
  props: ['ascending']
}
</script>

<style lang="scss">
.sort-arrow {
  cursor: pointer;
  display: none;

  @media (min-width: 600px) {
    display: block
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assets/SortArrow.vue